import React, { ReactElement } from 'react';
import styled from 'styled-components';
import SortIcon from '@material-ui/icons/Sort';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
//
import colors from 'theme/colors';
import { HeaderGroup } from 'react-table';

const { globalIcon } = colors;

const Container = styled.span`
  padding-left: 10px;
  padding-right: 10px;
  color: ${globalIcon};

  svg {
    height: 0.9em;
    width: 0.9em;
  }
`;

const SortIconContainer = styled.span`
  svg {
    height: 0.7em;
    width: 0.7em;
  }
`;

function isSortedDown(isSortedDesc = false) {
  return isSortedDesc ? <ArrowDropDown /> : <ArrowDropUp />;
}

export function renderSortIcon(column: HeaderGroup<object>): ReactElement | null {
  const { id, isSorted, isSortedDesc } = column;
  if (id === 'selection') {
    return null;
  }
  return (
    <Container>
      {isSorted ? (
        isSortedDown(isSortedDesc)
      ) : (
        <SortIconContainer>
          <SortIcon />
        </SortIconContainer>
      )}
    </Container>
  );
}
